import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

export const CarouselContainer = styled.div`
    position: relative;
    width: 100%;
    z-index: 1;

    .skeletons-wrapper {
        display: block;
        height: 435px;
        margin-top: 24px;
        white-space: nowrap;
        overflow: hidden;
    }

    .skeleton-item {
        display: inline-block;
        width: 352px;
        height: 410px;

        @media (max-width: ${wideBreakpoints.mobile}) {
            width: 343px;
            height: 399px;
        }
    }

    .skeleton-item:not(:last-child) {
        margin-right: 32px;
    }
`;
